export interface HttpResult {
  result: unknown[];
  paginationInfo: {
    pageIndex: number;
    pageSize: number;
    totalCount: number;
  };
}
